import { formatDate } from "@/utils";
import CheckedForColumnsVue from "@/components/functionals/checkedForColumns.vue";
import RenderCheck from "@/components/functionals/RenderCheck.vue";

export const GetExpiredAccsWithoutExecution = async function (thiss) {
  //console.log("entre a la funcion que llama la tabla");
  //console.log(thiss);
  /* 
    let param = {
        params: {
            RowType: 1
        }
    }
    */
  let tableData = [];
  if (
    //thiss.currentUser.Roles.some((e) => e.Id === 32 || e.Id === 37)
    thiss.currentUser.PositionID == 16 ||
    thiss.currentUser.PositionID == 129 ||
    thiss.currentUser.PositionID == 130
  ) {
    await thiss.$http
      .get("/api/CashFlow/GetCashFlowExpiredDetails", {
        params: {
          RowType: 1
        }
      })
      .then((result) => {
        //console.log("cuentas de ingresos sin ejecutar", result);
        tableData = result.data;
      })
      .catch((err) => {
        console.error("Error al consultar las cuentas sin ejecutar: ", err);
      })
      .finally(() => {});
  } else {
    tableData = [];
  }
  return tableData;
};

export const ExpiredAccsWithoutExecutionColumns = [
  {
    prop: "Id",
    label: "NO.",
    width: 90,
    sortable: true
  },
  {
    prop: "AccountNumber",
    label: "No. Cuenta",
    minWidth: 150,
    sortable: true
  },
  {
    prop: "AccountName",
    label: "Nombre",
    minWidth: 200,
    sortable: true
  },
  {
    prop: "LookingForward",
    label: "Proyecta",
    minWidth: 120,
    sortable: true,
    formatter: CheckedForColumnsVue
  },
  {
    prop: "Executed",
    label: "Ejecutado",
    minWidth: 120,
    sortable: true,
    formatter: RenderCheck
  },
  {
    prop: "Amount",
    label: "Monto proyectado",
    minWidth: 200,
    sortable: true,
    formatter: ({ Amount }) => {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });

      return formatter.format(Amount);
    }
  },
  {
    prop: "PostingDate",
    label: "Ultimo monto ejecutado",
    minWidth: 205,
    sortable: true,
    formatter: (row) => formatDate(row.PostingDate, "DD/MM/YYYY")
  },
  {
    prop: "Type",
    label: "Tipo de cuenta",
    minWidth: 120,
    sortable: true,
    formatter: CheckedForColumnsVue
  }
];

export const ExpiredAccsWithoutExecutionActions = [
  {
    icon: "el-icon-date",
    label: "Cambiar fecha de pago",
    command: "change-cashflow-date-payment"
  },
  /*
      {
        icon: "el-icon-edit-outline",
        label: "Editar nombre de cuenta",
        command: "edit-account"
      },
      */
  {
    icon: "el-icon-finished",
    label: "Ejecutar",
    command: "execute"
  }
  /*
      {
        label: "Proyectar",
        command: "to-project",
        icon: "el-icon-video-camera"
      },
      {
        icon: "el-icon-delete",
        label: "Eliminar",
        command: "delete"
      }
      */
];

// export const ExpiredAccsWithoutExecutionActionHandler = function ({ command, row }, thiss) {
//   const actions = {
//     "change=cashflow-date-payment": () => {
//       thiss.$refs.changePostingDate.show(row);
//     },
//     execute: () => {
//       toExecute(row.Id, thiss);
//     },
//     /*
//     "to-project": () => {
//       this.lookingForward(row);
//     },
//     delete: () => {
//       this.deleteDetaislAccount(row.Id);
//     },
//     "edit-account": () => {
//       //console.log ("popconfirm: ", this.$refs.popconfirm)
//       //this.$refs.popconfirm.reference
//       this.$prompt(
//         "Por favor ingrese el nuevo nombre para la cuenta",
//         "Tip",
//         {
//           confirmButtonText: "Cambiar",
//           cancelButtonText: "Cancelar",
//           inputPattern: /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
//           inputErrorMessage: "Nombre invalido"
//         }
//       )
//         .then(({ value }) => {
//           //console.log("value: ",value, "\n row: ",row);
//           this.$http
//             .put("/api/CashFlow/EditCashFlowDetailName", {
//               Id: row.Id,
//               Type: row.Type,
//               AccountName: value
//             })
//             .then((resp) => {
//               resp;
//               this.getData();
//             });
//           this.$message({
//             type: "success",
//             message: "El numbro nombre para esta cuenta es: " + value
//           });
//         })
//         .catch(() => {
//           this.$message({
//             type: "info",
//             message: "Cambio de nombre de cuenta Cancelado"
//           });
//         });
//     }
//     */
//   };
//   actions[command]();
//   return;
// }

// const toExecute = function (id, thiss) {
//     thiss.loading = true;
//     thiss.$http
//       .post("/api/CashFlow/Executed", {
//         RowDetailID: id
//       })
//       .then(({ data }) => {
//         if (data == true) {
//             thiss.$notify.success({
//             duration: 5000,
//             message: "Cuenta ejecutada correctamente",
//             title: "Información",
//             position: "top-left"
//           });

//           thiss.$emit("refresh", thiss.row.Id);
//           thiss.getData();
//         }
//       })
//       .catch((error) => {
//         thiss.$message.error("Error al consultar los Registros");
//         console.error(error);
//       })
//       .finally(() => {
//         thiss.loading = false;
//       });
//   }
